import styled from "styled-components";

import Radio from "@8x8/oxygen-radio";

import { FlexHorizontalContainer } from "@/react/features/styled/WidthContainers";

export const EmailSearchContainer = styled(FlexHorizontalContainer)`
  gap: 50px;
  width: 90%;
  max-width: 100%;
`;

export const EmailEntryContainer = styled.div`
  width: 50%;
`;

export const DateSelectionContainer = styled.div`
  opacity: ${(props) => (props?.isDisabled ? 0.5 : 1)};
`;

export const SearchMethodRadioButton = styled(Radio)`
  padding: 10px 0 0 0;
  margin-right: 5px;
`;
